import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TitanIconComponent } from 'src/app/user-interface/titan-icon/titan-icon.component';

@Component({
  selector: 'app-empty-conversation-state',
  templateUrl: './empty-conversation-state.component.html',
  styleUrls: ['./empty-conversation-state.component.scss'],
  standalone: true,
  imports: [CommonModule, TitanIconComponent]
})
export class EmptyConversationStateComponent {
  @Output() promptSelected = new EventEmitter<string>();

  examplePrompts = [
    'Young professionals interested in technology',
    'Parents with children aged 5-12',
    'Fitness enthusiasts in urban areas',
    'Business decision makers'
  ];

  onPromptClick(prompt: string): void {
    this.promptSelected.emit(prompt);
  }
}
